export const config = {
    std: {
        api: 'https://fanops-dev.fifa.org/api',
        field: {
            tournaments: {
                name: 'tournament',
                id: 'tournamentId'
            },
            roles: {
                name: 'roles',
                id: 'roleIds'
            },
            teams: {
                name: 'teams',
                id: 'teamIds'
            }
        }
    },
    prod: {
        api: 'https://fanops.fifa.org/api',
        field: {
            tournaments: {
                name: 'tournament',
                id: 'tournamentId'
            },
            roles: {
                name: 'roles',
                id: 'roleIds'
            },
            teams: {
                name: 'teams',
                id: 'teamIds'
            }
        }
    }
}